/* eslint jsx-a11y/no-static-element-interactions: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { branch, renderNothing } from 'recompose';
import Svg from 'rp-react-svg-icon';

function Lightbox({ onClose, children, className }) {
  let overlayContentNode;

  const onOutsideClick = (event) => {
    if (overlayContentNode && !overlayContentNode.contains(event.target)) {
      onClose();
    }
  };

  return (
    <div
      className="ui-overlay"
      onClick={onOutsideClick}
    >
      <div className="ui-overlay__container">
        <div
          className={classNames('ui-modal', 'ui-modal_mobile', className)}
          ref={(node) => { overlayContentNode = node; }}
        >
          <div
            tabIndex={0}
            role="button"
            className="ui-modal__closeBtn"
            onClick={onClose}
          >
            <Svg
              iconName="cross"
              size="Medium"
            />
          </div>
          <div className="ui-modal__canvas">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

Lightbox.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default branch(
  props => !props.open,
  renderNothing,
)(Lightbox);
